module.exports = __webpack_public_path__ + "img/setting.a48ef062.png";